import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { IceapiService } from '../../../../../services';
import { DataService } from '../../../../../services/data.service';
import { MeasurementService } from '../../../../../services/measurement.service';
import { FlangeDimensionModel, FlangeDimensionsByFlangeTypeModel } from '../../../models';
import { ControlData } from '../../../models/control-data';
import { DiagramDimensionValidationModel } from '../../../models/diagram-dimension-validation-model';
import { DiagramInfo } from '../../../models/diagram-info';
import { DiagramMappings } from '../../../models/diagram-mappings';
import { Router } from '@angular/router';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-diagram-flange-overrides',
    templateUrl: './diagram-flange-overrides.component.html',
    styleUrls: ['./diagram-flange-overrides.component.scss'],
    standalone: false
})
export class DiagramFlangeOverridesComponent implements OnInit {
    @Input()
    set diagramInfo(value: DiagramInfo) {
        this._diagramInfo = value;
        this.loadDiagramData();
    }
    get diagramInfo(): DiagramInfo {
        return this._diagramInfo;
    }

    @Input()
    set isEditable(value: boolean) {
        this._isEditable = value;
        // if (value) this.setFormValues();
    }
    get isEditable(): boolean {
        return this._isEditable;
    }
    @Input() isRedirect: boolean;
    @Input() calculationType: CalculationType;
    @Output() diagram: EventEmitter<DiagramInfo> = new EventEmitter();
    @Output() CalcOverrides: EventEmitter<ControlData> = new EventEmitter();
    @Output() DiagramFormData: EventEmitter<any> = new EventEmitter();
    destroy$ = new Subject();

    loading: boolean = false;
    diagramDimensions: DiagramDimensionValidationModel[];
    flangeDimensions: FlangeDimensionModel[];
    flangeDimensionsByFlangeType: FlangeDimensionsByFlangeTypeModel;
    diagramMappings: Map<string, DiagramMappings>;
    flangeDiagramFormGroup: UntypedFormGroup;
    flangeBoltHoleDiameterDefault: string = '0.00 mm';
    flangeHeightDefault: string = '0.00 mm';
    flangeHubDiameterDefault: string = '0.00 mm';
    flangeNeckODDefault: string = '0.00 mm';
    flangeODDefault: string = '0.00 mm';
    flangePCDDefault: string = '0.00 mm';
    flangeThicknessDefault: string = '0.00 mm';
    flangeSocketIDDefault: string = '0.00 mm';
    flangeIDDefault: string = '0.00 mm';

    private _diagramInfo: DiagramInfo;
    private _isEditable: boolean;

    constructor(
        private fb: UntypedFormBuilder,
        private iceapi: IceapiService,
        private measSvc: MeasurementService,
        private dataSvc: DataService,
        private user_utility: UserUtilityService,
        private router: Router,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.loadDefaultValues();
        this.flangeDiagramFormGroup = this.fb.group({
            flangeBoltHoleDiameter: [this.flangeBoltHoleDiameterDefault, { updateOn: 'blur' }],
            flangeHeight: [this.flangeHeightDefault, { updateOn: 'blur' }],
            flangeHubDiameter: [this.flangeHubDiameterDefault, { updateOn: 'blur' }],
            flangeID: [this.flangeIDDefault, { updateOn: 'blur' }],
            flangeNeckOD: [this.flangeNeckODDefault, { updateOn: 'blur' }],
            flangeOD: [this.flangeODDefault, { updateOn: 'blur' }],
            flangePCD: [this.flangePCDDefault, { updateOn: 'blur' }],
            flangeSocketID: [this.flangeSocketIDDefault, { updateOn: 'blur' }],
            flangeThickness: [this.flangeThicknessDefault, { updateOn: 'blur' }],
        });

        this.flangeDiagramFormGroup
            .get('flangeBoltHoleDiameter')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeBoltHoleDiameter', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeHeight')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeHeight', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeHubDiameter')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeHubDiameter', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeNeckOD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeNeckOD', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeOD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeOD', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangePCD')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangePCD', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeThickness')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeThickness', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeSocketID')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeSocketID', value);
                }
            });
        this.flangeDiagramFormGroup
            .get('flangeID')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.setItemAndEmit('flangeID', value);
                }
            });
    }

    initialize() {
        this.flangeDiagramFormGroup.get('flangeID').setValue(this.flangeIDDefault);
        this.flangeDiagramFormGroup.get('flangeSocketID').setValue(this.flangeSocketIDDefault);
        this.flangeDiagramFormGroup.get('flangeBoltHoleDiameter').setValue(this.flangeBoltHoleDiameterDefault);
        this.flangeDiagramFormGroup.get('flangeHeight').setValue(this.flangeHeightDefault);
        this.flangeDiagramFormGroup.get('flangeHubDiameter').setValue(this.flangeHubDiameterDefault);
        this.flangeDiagramFormGroup.get('flangeNeckOD').setValue(this.flangeNeckODDefault);
        this.flangeDiagramFormGroup.get('flangeOD').setValue(this.flangeODDefault);
        this.flangeDiagramFormGroup.get('flangePCD').setValue(this.flangePCDDefault);
        this.flangeDiagramFormGroup.get('flangeThickness').setValue(this.flangeThicknessDefault);
        this.flangeDiagramFormGroup.get('flangeSocketID').setValue(this.flangeSocketIDDefault);
    }

    loadDefaultValues() {
        if (this.isRedirect && this.dataSvc.calculationData != null && this.dataSvc.calculationData.input.dimensionOverrides != null) {
            if (this.dataSvc.calculationData.input.calculationType == CalculationType.OverriddenFlange) {
                this.isEditable = true;
                // this.setFormValues();
            }
            this.flangeBoltHoleDiameterDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeBoltHoleDiameter ?? '0.00 mm';
            this.flangeHeightDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeHeight ?? '0.00 mm';
            this.flangeHubDiameterDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeHubDiameter ?? '0.00 mm';
            this.flangeNeckODDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeNeckOD ?? '0.00 mm';
            this.flangeODDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeOD ?? '0.00 mm';
            this.flangePCDDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangePCD ?? '0.00 mm';
            this.flangeThicknessDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeThickness ?? '0.00 mm';
            this.flangeSocketIDDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeSocketID ?? '0.00 mm';
            this.flangeIDDefault = this.dataSvc.calculationData.input.dimensionOverrides.flangeID ?? '0.00 mm';
        }
    }

    async loadDiagramData() {
        if (this.diagramInfo.diagramId == null || this.diagramInfo.diagramId == undefined) {
            this.diagramDimensions = [];
        } else {
            await this.getDiagramDimensions();
            await this.getFlangeDimensions();
            if (this.isEditable) this.setFormValues();
        }
    }

    async getDiagramDimensions() {
        if (this.diagramInfo != undefined) {
            await this.iceapi
                .getDiagramDimensionValidations(this.diagramInfo.diagramId, 'FlangeType')
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        this.diagramDimensions = res.response;
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });

            if (this.diagramDimensions !== null) {
                if (this.calculationType == CalculationType.CustomFlange) {
                    this.initialize();
                }
                this.loadDiagramMappings();
                Object.keys(this.flangeDiagramFormGroup.controls).forEach((controlName) => {
                    const control = this.flangeDiagramFormGroup.get(controlName);

                    // You can now use controlName and control (which is a FormControl)
                    let match = this.diagramDimensions.findIndex((x) => x.key == controlName);
                    if (match <= -1) {
                        control.setValue(null);
                    }
                });

                this.DiagramFormData.emit(this.flangeDiagramFormGroup);

                if (this.isEditable) {
                    this.setValidations();
                }
            }
        }
    }

    async getFlangeDimensions() {
        if (this.isEditable === false && this.diagramInfo !== undefined) {
            await this.iceapi
                .getFlangeDimensions(this.diagramInfo.pressureClassId, this.diagramInfo.pipesizeId)
                .toPromise()
                .then((res) => {
                    if (res.success) {
                        this.flangeDimensions = res.response;
                        this.globalEmittersService.flangeDimension.next(res.response); // * cached in thread type component
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
            if (this.flangeDimensions != null) {
                await this.iceapi
                    .getFlangeDimensionsByFlangeType(this.diagramInfo.flangeTypeId, this.flangeDimensions[0]?.flangeDimensionId)
                    .toPromise()
                    .then((res) => {
                        if (res.success) {
                            this.flangeDimensionsByFlangeType = res.response;
                        } else {
                            this.user_utility.errorModelPopup(res.message);
                        }
                    })
                    .catch((e) => {
                        console.warn(e);
                    });
                if (this.flangeDimensionsByFlangeType != null) {
                    for (var key of this.diagramMappings.keys()) {
                        let value = '0.00 mm';
                        switch (key) {
                            case 'flangeOD':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensions[0].flangeOutsideDiameter, UnitType.DefaultLengthUnit);
                                break;
                            case 'flangePCD':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensions[0].pitchCircleDiameter, UnitType.DefaultLengthUnit);
                                break;
                            case 'flangeBoltHoleDiameter':
                                if (this.diagramInfo.boltType == 'Metric') {
                                    value = this.measSvc.getUserPreferedValue(
                                        this.flangeDimensions[0].boltDimensionMetric.majorDiameterWithAllowance,
                                        UnitType.DefaultLengthUnit
                                    );
                                } else {
                                    value = this.measSvc.getUserPreferedValue(
                                        this.flangeDimensions[0].boltDimensionImperial.majorDiameterWithAllowance,
                                        UnitType.DefaultLengthUnit
                                    );
                                }
                                break;
                            case 'flangeHubDiameter':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.hubDiameter, UnitType.DefaultLengthUnit);
                                break;
                            case 'flangeHeight':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.flangeHeight, UnitType.DefaultLengthUnit);
                                break;
                            case 'flangeNeckOD':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.neckOutsideDiameter, UnitType.DefaultLengthUnit);
                                break;
                            case 'flangeThickness':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.flangeThickness, UnitType.DefaultLengthUnit);
                                break;
                            case 'flangeSocketID':
                                value = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.socketInsideDiameter, UnitType.DefaultLengthUnit);
                                break;
                        }
                        this.diagramMappings.get(key).value = value;
                    }
                }
                this.emitDiagramEvent(this.flangeDimensions[0]?.numberOfBolts);
            }
        } else {
        }
    }

    setItemAndEmit(controlName: string, value: string) {
        let correctedValue = this.measSvc.format(value, UnitType.DefaultLengthUnit);
        this.flangeDiagramFormGroup.get(controlName).patchValue(correctedValue, { emitEvent: false });

        let dimension = this.diagramDimensions.find((x) => x.key == controlName);
        if (dimension) {
            if (dimension !== null && (dimension.high !== null || dimension.low !== null)) {
                if (dimension.high !== undefined && dimension.high !== null) {
                    this.flangeDiagramFormGroup.controls[dimension.high].updateValueAndValidity({ emitEvent: false });
                    this.emitOverrides(dimension.high, this.flangeDiagramFormGroup.controls[dimension.high].value);
                }
                if (dimension.low !== undefined && dimension.low !== null) {
                    this.flangeDiagramFormGroup.controls[dimension.low].updateValueAndValidity({ emitEvent: false });
                    this.emitOverrides(dimension.low, this.flangeDiagramFormGroup.controls[dimension.low].value);
                }
            }
            this.emitOverrides(controlName, correctedValue);
            // this.setErrorsOnToolTip();
            this.setErrorMessage();
        }
    }

    private emitOverrides(controlName: string, correctedValue: string) {
        this.CalcOverrides.emit({ controlName: controlName, controlValue: correctedValue, isFormValid: this.flangeDiagramFormGroup.valid });
        this.DiagramFormData.emit(this.flangeDiagramFormGroup);
    }

    // setErrorsOnToolTip() {

    //   if (this.flangeDiagramFormGroup.invalid) {
    //     for (var controlName in this.flangeDiagramFormGroup.controls) {

    //       let val:string= this.flangeDiagramFormGroup.get(controlName).value;
    //       let unit= val.split(" ");
    //       if (this.flangeDiagramFormGroup.get(controlName).hasError('min') && this.flangeDiagramFormGroup.get(controlName).hasError('max')) {
    //         this.diagramMappings.get(controlName).toolTip = 'The value range in between :' + this.flangeDiagramFormGroup.get(controlName).errors.min.min+'-'+ + this.flangeDiagramFormGroup.get(controlName).errors.max.max;
    //       }
    //       else if (this.flangeDiagramFormGroup.get(controlName).hasError('max')) {
    //         this.diagramMappings.get(controlName).toolTip = 'The maximum allowed value is :' + this.measSvc.format(parseFloat(this.flangeDiagramFormGroup.get(controlName).errors.max.max).toString()+unit[1],UnitType.DefaultLengthUnit);
    //       }
    //       else if (this.flangeDiagramFormGroup.get(controlName).hasError('min')) {
    //         this.diagramMappings.get(controlName).toolTip = 'The minimum allowed value is :' + this.measSvc.format(parseFloat(this.flangeDiagramFormGroup.get(controlName).errors.min.min).toString()+unit[1],UnitType.DefaultLengthUnit);
    //       }
    //     }
    //   }

    // }

    //set-up now validator message acourding to range
    setErrorMessage() {
        if (this.flangeDiagramFormGroup.invalid) {
            this.diagramDimensions.forEach((x) => {
                if (x.low && x.high) {
                    this.diagramMappings.get(x.key).toolTip =
                        'The value must be within ' + this.flangeDiagramFormGroup.get(x.low).value + ' - ' + this.flangeDiagramFormGroup.get(x.high).value;
                } else if (x.low) {
                    this.diagramMappings.get(x.key).toolTip = 'The value must be equal to or greater than ' + this.flangeDiagramFormGroup.get(x.low).value;
                } else if (x.high) {
                    this.diagramMappings.get(x.key).toolTip = 'The value must be equal to or lesser than ' + this.flangeDiagramFormGroup.get(x.high).value;
                }
            });
        }
    }

    getValidatorsOnControl(controlName) {
        const validator = this.flangeDiagramFormGroup.get(controlName).validator({} as AbstractControl);
        return validator;
    }

    emitDiagramEvent(numberOfBolts: number) {
        let newDiagramInfo = new DiagramInfo();
        newDiagramInfo.diagramType = 'Torque Sequence';
        newDiagramInfo.pressureClassId = this.diagramInfo.pressureClassId;
        newDiagramInfo.pipesizeId = this.diagramInfo.pipesizeId;
        newDiagramInfo.noOfBolts = numberOfBolts;
        this.diagram.emit(newDiagramInfo);
    }

    loadDiagramMappings() {
        // file deepcode ignore CollectionUpdatedButNeverQueried: <please specify a reason of ignoring this>
        this.diagramMappings = new Map<string, DiagramMappings>();
        for (var dimension of this.diagramDimensions) {
            this.diagramMappings.set(dimension.key, new DiagramMappings());
        }
    }

    setValidations() {
        this.flangeDiagramFormGroup.clearValidators();
        for (var dimension of this.diagramDimensions) {
            let controlName = dimension.key;

            if (dimension.low !== undefined && dimension.low !== null && dimension.high !== undefined && dimension.high !== null) {
                let lowCtrlName = dimension.low;
                let highCtrlName = dimension.high;

                this.flangeDiagramFormGroup
                    .get(controlName)
                    .setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.min(this.measSvc.extractNumarical(this.flangeDiagramFormGroup.controls[lowCtrlName].value))(control),
                        (control: AbstractControl) =>
                            Validators.max(this.measSvc.extractNumarical(this.flangeDiagramFormGroup.controls[highCtrlName].value))(control),
                    ]);
            } else if (dimension.low !== undefined && dimension.low !== null) {
                let lowCtrlName = dimension.low;
                this.flangeDiagramFormGroup
                    .get(controlName)
                    .setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.min(this.measSvc.extractNumarical(this.flangeDiagramFormGroup.controls[lowCtrlName].value))(control),
                    ]);
            } else if (dimension.high !== undefined && dimension.high != null) {
                let highCtrlName = dimension.high;
                this.flangeDiagramFormGroup
                    .get(controlName)
                    .setValidators([
                        Validators.required,
                        (control: AbstractControl) =>
                            Validators.max(this.measSvc.extractNumarical(this.flangeDiagramFormGroup.controls[highCtrlName].value))(control),
                    ]);
            }
        }

        this.flangeDiagramFormGroup.updateValueAndValidity();
    }

    setFormValues() {
        if (this.router.url == '/informate/standardflange/false' || (this.router.url == '/informate/standardflange/true' && this.flangeDimensions?.length)) {
            this.flangeBoltHoleDiameterDefault = this.measSvc.getUserPreferedValue(
                this.flangeDimensions[0].boltDimensionMetric.majorDiameterWithAllowance,
                UnitType.DefaultLengthUnit
            );
            this.flangeHeightDefault = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.flangeHeight, UnitType.DefaultLengthUnit);
            this.flangeHubDiameterDefault = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.hubDiameter, UnitType.DefaultLengthUnit);
            this.flangeNeckODDefault = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.neckOutsideDiameter, UnitType.DefaultLengthUnit);
            this.flangeODDefault = this.measSvc.getUserPreferedValue(this.flangeDimensions[0].flangeOutsideDiameter, UnitType.DefaultLengthUnit);
            this.flangePCDDefault = this.measSvc.getUserPreferedValue(this.flangeDimensions[0].pitchCircleDiameter, UnitType.DefaultLengthUnit);
            this.flangeThicknessDefault = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.flangeThickness, UnitType.DefaultLengthUnit);
            this.flangeSocketIDDefault = this.measSvc.getUserPreferedValue(this.flangeDimensionsByFlangeType.socketInsideDiameter, UnitType.DefaultLengthUnit);
            // this.flangeIDDefault = '0.00 mm';
            this.flangeDiagramFormGroup.get('flangeBoltHoleDiameter').setValue(this.flangeBoltHoleDiameterDefault);
            this.flangeDiagramFormGroup.get('flangeHeight').setValue(this.flangeHeightDefault);
            this.flangeDiagramFormGroup.get('flangeHubDiameter').setValue(this.flangeHubDiameterDefault);
            this.flangeDiagramFormGroup.get('flangeNeckOD').setValue(this.flangeNeckODDefault);
            this.flangeDiagramFormGroup.get('flangeOD').setValue(this.flangeODDefault);
            this.flangeDiagramFormGroup.get('flangePCD').setValue(this.flangePCDDefault);
            this.flangeDiagramFormGroup.get('flangeThickness').setValue(this.flangeThicknessDefault);
            this.flangeDiagramFormGroup.get('flangeSocketID').setValue(this.flangeSocketIDDefault);
            this.setValidations();
        }
        // this.flangeDiagramFormGroup.get('flangeBoltHoleDiameter').setValue(this.flangeBoltHoleDiameterDefault);
    }
}
